import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Loader extends Component {
    static propTypes = {
        contentId: PropTypes.string.isRequired,
        isLoaded: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
        showLoader: PropTypes.bool.isRequired,
    }

    render() {
        const { isLoading, isLoaded, showLoader, contentId } = this.props

        if (isLoading && !isLoaded) {
            return (
                <div className={'user-profile-screen-loader'}>
                    <div className={'center'}>
                        <div className={'text'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.screenLoader.${contentId}`} />
                        </div>
                        <div className={'gif'} />
                    </div>
                </div>
            )
        }

        if ((isLoading && isLoaded) || showLoader) {
            return <div className={'user-profile-top-loader'} />
        }

        return null
    }
}
